import React from 'react';

export const BULLET_REGEX = /^([-•–—])\s+/;

export function testPattern(regex: RegExp, line: string) {
    return regex.test(line);
}

export function replacePattern(regex: RegExp, line: string, replacement: string = '') {
    return line.replace(regex, replacement);
}

export function flushList(key: string, elements: React.ReactNode[], currentList: string[]) {
    if (currentList.length === 0) return;
    elements.push(
        <ul key={key} style={{ listStyleType: 'disc', paddingLeft: '20px', marginBottom: '8px' }}>
            {currentList.map((item, i) => (
                <li key={i}>{item}</li>
            ))}
        </ul>,
    );
    currentList.length = 0;
}
/**
 * Formats backend text into proper UI rendering.
 *
 * Handles:
 * - \n, \r\n, \r → line breaks
 * - \n\n → paragraph breaks
 * - Bullets: -, •, –, —
 * - Mixed content (paragraph + bullets)
 * - Extra spaces trimming
 * - Safe rendering (no HTML execution)
 */
export function formatTextContent(text: string | null | undefined): React.ReactNode {
    if (!text || typeof text !== 'string' || !text.trim()) return null;

    const normalized = text.replace(/\r\n|\r/g, '\n').trim();

    const blocks = normalized.split(/\n[ \t]*\n+/);

    return (
        <>
            {blocks.map((block, blockIndex) => {
                const rawLines = block.split('\n');

                // Keep structure but trim safely
                const lines = rawLines.map((l) => l.trim()).filter((l) => l.length > 0);

                if (lines.length === 0) return null;

                return (
                    <div key={blockIndex} style={{ marginBottom: '8px' }}>
                        {renderLines(lines)}
                    </div>
                );
            })}
        </>
    );
}

/**
 * Renders lines with proper handling of:
 * - Bullets
 * - Paragraphs
 * - Mixed content
 */
export function renderLines(lines: string[]) {
    const elements: React.ReactNode[] = [];
    let currentList: string[] = [];

    lines.forEach((line, index) => {
        if (testPattern(BULLET_REGEX, line)) {
            currentList.push(replacePattern(BULLET_REGEX, line));
        } else {
            flushList(`ul-${index}`, elements, currentList);
            elements.push(
                <p key={`p-${index}`} style={{ margin: '0 0 4px 0' }}>
                    {line}
                </p>,
            );
        }
    });

    flushList('ul-last', elements, currentList);

    return elements;
}
